exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#screen-window{border-radius:4px;box-shadow:0 0 6px 0 rgba(0,0,0,.8)}#screen-window img.logo{max-height:50px}#screen-window .option{width:100%;border:2px solid #333;font-size:22px;margin-bottom:10px;line-height:22px;padding:15px 10px;font-family:bebas-neue,sans-serif}#screen-window .option.active{background:#fedc01;border-color:#fedc01}#screen-window #content{padding-left:32px;padding-right:32px}#screen-window #write-in{min-height:150px;justify-content:center}#screen-window #write-in input{border-radius:2px;max-width:25px}#screen-window #write-in .row{justify-content:center}#screen-window .text{display:flex}", ""]);

// exports
